import mediaQueries from '../assets/styles/mediaQueriesToJs.module.scss';

export const SIZES: { [key: string]: number } = Object.keys(mediaQueries)
  .reduce((result: { [key: string]: number }, key) => {
    result[key] = parseInt(mediaQueries[key], 10);

    return result;
  }, {});